<app-help-page mainVideo="managing-metrics"
               [tutorials]="['metrics-in-adloop', 'normalized-metrics']"
               [videos]="['managing-metrics']"></app-help-page>
